module.exports={
    "financial_historicoFatura": {
        "id": "financial_historicoFatura",
        "eventName": "fin_visualizar_fatura",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Historico de fatura do financeiro",
        "eventValue": 0.0
    },
    "financial_atualizarDados": {
        "id": "financial_atualizarDados",
        "eventName": "fin_atualizar_dados",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Atualizar dados de cobrança",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_razaoSocial": {
        "id": "dadosCobrancaModal_razaoSocial",
        "eventName": "fin_razao_social",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_cpfCnpj": {
        "id": "dadosCobrancaModal_cpfCnpj",
        "eventName": "fin_cpf_cnpj",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_buttonCpfCnpj": {
        "id": "dadosCobrancaModal_buttonCpfCnpj",
        "eventName": "fin_button_cpf_cnpj",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_pais": {
        "id": "dadosCobrancaModal_pais",
        "eventName": "fin_pais",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": "{{label}}"
    },
    "dadosCobrancaModal_cep": {
        "id": "dadosCobrancaModal_cep",
        "eventName": "fin_cep",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_estado": {
        "id": "dadosCobrancaModal_estado",
        "eventName": "fin_estado",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": "{{label}}"
    },
    "dadosCobrancaModal_cidade": {
        "id": "dadosCobrancaModal_cidade",
        "eventName": "fin_cidade",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": "{{label}}"
    },
    "dadosCobrancaModal_bairro": {
        "id": "dadosCobrancaModal_bairro",
        "eventName": "fin_bairro",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_rua": {
        "id": "dadosCobrancaModal_rua",
        "eventName": "fin_rua",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_numero": {
        "id": "dadosCobrancaModal_numero",
        "eventName": "fin_numero",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_complemento": {
        "id": "dadosCobrancaModal_complemento",
        "eventName": "fin_complemento",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_ddd": {
        "id": "dadosCobrancaModal_ddd",
        "eventName": "fin_ddd",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_telefone": {
        "id": "dadosCobrancaModal_telefone",
        "eventName": "fin_telefone",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_emailFinanceiro": {
        "id": "dadosCobrancaModal_emailFinanceiro",
        "eventName": "fin_email_financeiro",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_emailop1": {
        "id": "dadosCobrancaModal_emailop1",
        "eventName": "fin_email_opcional1",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_emailop2": {
        "id": "dadosCobrancaModal_emailop2",
        "eventName": "fin_email_opcional2",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_cancelar": {
        "id": "dadosCobrancaModal_cancelar",
        "eventName": "fin_cancelar",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "dadosCobrancaModal_salvar": {
        "id": "dadosCobrancaModal_salvar",
        "eventName": "fin_salvar",
        "eventProduct": "Financeiro",
        "eventCategory": "Financeiro",
        "eventAction": "Modal Dados de Cobranca",
        "eventValue": 0.0
    },
    "invoice_modalFaturaQtdeUsuarioProduto": {
        "id": "invoice_modalFaturaQtdeUsuarioProduto",
        "eventName": "fin_visualizar_usuario_por_produto",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique na quantidade de usuários por produto na fatura",
        "eventValue": 0.0
    },
    "invoice_modalUsuarioVoltar": {
        "id": "invoice_modalUsuarioVoltar",
        "eventName": "fin_voltar_fatura",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no < para voltar para visualização da fatura",
        "eventValue": 0.0
    },
    "invoice_modalUsuariofechar": {
        "id": "invoice_modalUsuariofechar",
        "eventName": "fin_fechar_modal_usuarios",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no X para fechar a visualização de usuários na fatura",
        "eventValue": 0.0
    },
    "invoice_modalUsuarioVoltarResumoFatura": {
        "id": "invoice_modalUsuarioVoltarResumoFatura",
        "eventName": "fin_voltar_resumo_fatura",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao Voltar para o resumo de faturas",
        "eventValue": 0.0
    },
    "invoice_modalUsuarioVerUsuarioProduto": {
        "id": "invoice_modalUsuarioVerUsuarioProduto",
        "eventName": "fin_visualizar_usuario_produto",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para visualizar usuários por produto",
        "eventValue": 0.0
    },
    "invoice_modalFaturaNF": {
        "id": "invoice_modalFaturaNF",
        "eventName": "fin_click_nf",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para visualizar a nota fiscal",
        "eventValue": 0.0
    },
    "invoice_modalFaturaExcel": {
        "id": "invoice_modalFaturaExcel",
        "eventName": "fin_click_excel",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para gerar o excel da fatura",
        "eventValue": 0.0
    },
    "invoice_modalFaturaPdf": {
        "id": "invoice_modalFaturaPdf",
        "eventName": "fin_click_pdf",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para gerar o PDF da fatura",
        "eventValue": 0.0
    },
    "invoice_modalFaturaSegundaVia": {
        "id": "invoice_modalFaturaSegundaVia",
        "eventName": "fin_click_segunda_via",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para gerar a segunda via da fatura",
        "eventValue": 0.0
    },
    "invoice_modalFaturaEfetuarPagamento": {
        "id": "invoice_modalFaturaEfetuarPagamento",
        "eventName": "fin_click_efetuar_pagamento",
        "eventProduct": "Financeiro",
        "eventCategory": "Fatura",
        "eventAction": "Clique no botao para efetuar o pagamento",
        "eventValue": 0.0
    }
}